"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "allergy-form" };
var _hoisted_2 = { class: "form-header" };
var _hoisted_3 = { class: "header-content" };
var _hoisted_4 = { class: "form-section" };
var _hoisted_5 = { class: "form-grid" };
var _hoisted_6 = { class: "form-group full-width" };
var _hoisted_7 = { class: "input-with-icon" };
var _hoisted_8 = {
    key: 0,
    class: "suggestions-dropdown"
};
var _hoisted_9 = {
    key: 0,
    class: "suggestion-loading"
};
var _hoisted_10 = ["onClick"];
var _hoisted_11 = { class: "suggestion-name" };
var _hoisted_12 = {
    key: 0,
    class: "suggestion-badge rxnorm"
};
var _hoisted_13 = {
    key: 1,
    class: "suggestion-badge local"
};
var _hoisted_14 = {
    key: 0,
    class: "search-indicator"
};
var _hoisted_15 = { class: "form-group" };
var _hoisted_16 = { class: "form-group" };
var _hoisted_17 = { class: "form-group" };
var _hoisted_18 = {
    key: 0,
    class: "form-group"
};
var _hoisted_19 = { class: "form-group" };
var _hoisted_20 = { class: "form-section" };
var _hoisted_21 = { class: "form-grid" };
var _hoisted_22 = { class: "form-group" };
var _hoisted_23 = { class: "severity-options" };
var _hoisted_24 = ["value"];
var _hoisted_25 = { class: "severity-label" };
var _hoisted_26 = { class: "form-group" };
var _hoisted_27 = { class: "criticality-options" };
var _hoisted_28 = ["value"];
var _hoisted_29 = {
    key: 0,
    class: "glyphicon glyphicon-exclamation-sign bi bi-exclamation"
};
var _hoisted_30 = {
    key: 1,
    class: "glyphicon glyphicon-ok-circle bi bi-check"
};
var _hoisted_31 = {
    key: 2,
    class: "glyphicon glyphicon-question-sign bi bi-question"
};
var _hoisted_32 = { class: "criticality-label" };
var _hoisted_33 = { class: "form-section" };
var _hoisted_34 = { class: "manifestations-grid" };
var _hoisted_35 = ["checked", "onChange"];
var _hoisted_36 = { class: "manifestation-name" };
var _hoisted_37 = {
    key: 0,
    class: "selected-reactions"
};
var _hoisted_38 = { class: "reactions-list" };
var _hoisted_39 = { class: "reaction-name" };
var _hoisted_40 = ["onUpdate:modelValue"];
var _hoisted_41 = ["onClick"];
var _hoisted_42 = { class: "form-section" };
var _hoisted_43 = {
    key: 0,
    class: "cross-reactivity-warnings"
};
var _hoisted_44 = { class: "cross-items" };
var _hoisted_45 = ["checked", "onChange"];
var _hoisted_46 = {
    key: 1,
    class: "no-cross-reactivity"
};
var _hoisted_47 = { class: "form-section" };
var _hoisted_48 = { class: "editor-container" };
var _hoisted_49 = { class: "editor-toolbar" };
var _hoisted_50 = { class: "form-actions" };
var _hoisted_51 = ["disabled"];
var vue_3 = require("vue");
var vuex_1 = require("vuex");
var allergyStore_1 = require("@/stores/allergyStore");
var rxnormService_1 = require("@/services/rxnormService");
var apis_1 = require("@/constants/apis");
var axios_1 = require("axios");
//const CURR_API ="/keyon";
exports.default = (0, vue_1.defineComponent)({
    __name: 'AllergyForm',
    props: {
        allergyId: {}
    },
    emits: ["cancel", "saved"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var stores = (0, allergyStore_1.useAllergyStore)(); //pinia store
        var store = (0, vuex_1.useStore)(); //vuex store
        var allData = (0, vue_3.computed)(function () { var _a; return (_a = store.getters) === null || _a === void 0 ? void 0 : _a['login/getAllData']; });
        var props = __props;
        var emit = __emit;
        var editorRef = (0, vue_3.ref)(null);
        var form = (0, vue_3.ref)({
            name: '',
            type: '',
            status: 'active',
            severity: 'unknown',
            criticality: 'low',
            reactions: [],
            onsetDate: '',
            resolvedDate: '',
            verificationStatus: 'unconfirmed',
            comments: '',
            crossReactivity: []
        });
        var isEditing = (0, vue_3.computed)(function () { return !!props.allergyId; });
        var showSuggestions = (0, vue_3.ref)(false);
        var suggestions = (0, vue_3.ref)([]);
        var isSearching = (0, vue_3.ref)(false);
        var searchDebounceTimer = (0, vue_3.ref)(null);
        var severityOptions = [
            { value: 'mild', label: 'Mild' },
            { value: 'moderate', label: 'Moderate' },
            { value: 'severe', label: 'Severe' },
            { value: 'life-threatening', label: 'Life-Threatening' },
            { value: 'unknown', label: 'Unknown' }
        ];
        var criticalityOptions = [
            { value: 'low', label: 'Low Risk' },
            { value: 'high', label: 'High Risk' },
            { value: 'unable-to-assess', label: 'Unable to Assess' }
        ];
        var isFormatActive = (0, vue_3.ref)({
            bold: false,
            italic: false,
            underline: false
        });
        var crossReactivityWarnings = (0, vue_3.computed)(function () {
            if (!form.value.name)
                return [];
            //alert("Cross happending")
            console.log("Seee Wht Store Returns to CrossReactivityWarning");
            //console.log(stores.getCrossReactivityWarnings(form.value.name));
            return stores.getCrossReactivityWarnings(form.value.name);
        });
        var isFormValid = (0, vue_3.computed)(function () {
            return form.value.name.trim() !== '' &&
                form.value.type !== '' &&
                form.value.status !== '' &&
                form.value.severity !== '';
        });
        function searchAllergies() {
            var _this = this;
            var query = form.value.name.trim();
            // Clear previous timer
            if (searchDebounceTimer.value) {
                clearTimeout(searchDebounceTimer.value);
            }
            if (query.length < 2) {
                suggestions.value = [];
                showSuggestions.value = false;
                isSearching.value = false;
                return;
            }
            isSearching.value = true;
            // Debounce API calls to avoid rate limiting
            searchDebounceTimer.value = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                var results, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, 3, 4]);
                            return [4 /*yield*/, (0, rxnormService_1.searchAllAllergies)(query)];
                        case 1:
                            results = _a.sent();
                            suggestions.value = results;
                            showSuggestions.value = results.length > 0;
                            return [3 /*break*/, 4];
                        case 2:
                            error_1 = _a.sent();
                            console.warn('[AllergyForm] Search error:', error_1);
                            suggestions.value = [];
                            return [3 /*break*/, 4];
                        case 3:
                            isSearching.value = false;
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            }); }, 300);
        }
        function selectSuggestion(suggestion) {
            form.value.name = suggestion.name;
            showSuggestions.value = false;
            suggestions.value = [];
        }
        function isManifestationSelected(manifestation) {
            return form.value.reactions.some(function (r) { return r.manifestation === manifestation; });
        }
        function toggleManifestation(manifestation) {
            var idx = form.value.reactions.findIndex(function (r) { return r.manifestation === manifestation; });
            if (idx >= 0) {
                form.value.reactions.splice(idx, 1);
            }
            else {
                form.value.reactions.push({
                    manifestation: manifestation,
                    severity: 'moderate'
                });
            }
        }
        function removeManifestation(idx) {
            form.value.reactions.splice(idx, 1);
        }
        function toggleCrossReactivity(item) {
            var idx = form.value.crossReactivity.indexOf(item);
            if (idx >= 0) {
                form.value.crossReactivity.splice(idx, 1);
            }
            else {
                form.value.crossReactivity.push(item);
            }
        }
        function formatText(command) {
            var _a;
            document.execCommand(command, false);
            (_a = editorRef.value) === null || _a === void 0 ? void 0 : _a.focus();
            checkFormats();
        }
        function clearFormatting() {
            var _a;
            document.execCommand('removeFormat', false);
            (_a = editorRef.value) === null || _a === void 0 ? void 0 : _a.focus();
            checkFormats();
        }
        function checkFormats() {
            isFormatActive.value.bold = document.queryCommandState('bold');
            isFormatActive.value.italic = document.queryCommandState('italic');
            isFormatActive.value.underline = document.queryCommandState('underline');
        }
        function updateComments() {
            var _a;
            form.value.comments = ((_a = editorRef.value) === null || _a === void 0 ? void 0 : _a.innerHTML) || '';
        }
        function handleSubmit() {
            var _a, _b;
            if (!isFormValid.value)
                return;
            var manager = (_a = allData.value) === null || _a === void 0 ? void 0 : _a.manager;
            var patient = (_b = allData.value) === null || _b === void 0 ? void 0 : _b.patient;
            // Staff charting uses manager; patient self-service has no manager — use patient.
            var actorName = (manager === null || manager === void 0 ? void 0 : manager.providername) ||
                (manager === null || manager === void 0 ? void 0 : manager.name) ||
                [patient === null || patient === void 0 ? void 0 : patient.firstName, patient === null || patient === void 0 ? void 0 : patient.lastName].filter(Boolean).join(" ") ||
                (patient === null || patient === void 0 ? void 0 : patient.name) ||
                "";
            var actorSubaccount = (manager === null || manager === void 0 ? void 0 : manager.externid) || (patient === null || patient === void 0 ? void 0 : patient.externId) || "";
            var allergyData = {
                name: form.value.name,
                type: form.value.type,
                status: form.value.status,
                severity: form.value.severity,
                criticality: form.value.criticality,
                reactions: form.value.reactions,
                onsetDate: form.value.onsetDate || null,
                resolvedDate: form.value.resolvedDate || null,
                verificationStatus: form.value.verificationStatus,
                comments: form.value.comments,
                crossReactivity: form.value.crossReactivity,
                recordedBy: actorName,
                lastUpdatedBy: 'Current User'
            };
            if (isEditing.value && props.allergyId) {
                //I'll need to make an axios call here (object to pass) Updating the allery Info here 
                var content = {
                    MedicationAdmin: {
                        API_Meth: "UpdatePatientAllergyInfo",
                        accountnumber: allData.value.patient.externId2, //"904575107", 
                        npinumber: allData.value.patient.npi, // "123456789",
                        proflicensenumber: allData.value.patient.npi, //"609382", //insurance test
                        patientid: allData.value.patient.externId, //"709081242",
                        ordernumber: '36',
                        params: allergyData,
                        medname: allergyData.name || 'N/A',
                        allergyId: props.allergyId,
                        provsubaccount: actorSubaccount
                    }
                };
                try {
                    console.log(apis_1.CURR_API);
                    axios_1.default.post(apis_1.CURR_API + "/tswebhook.php", content)
                        .then(function (response) {
                        console.log("Logging Results of Axios Call");
                        console.log(response.data);
                        if (response.data && response.data != "" && response.data.status == "200-Successfull" && response.data.code == "1") {
                            var updated = stores.updateAllergy(String(props.allergyId), allergyData);
                            alert("Patient Allergy Updated Successfully.");
                            if (updated)
                                emit('saved', updated);
                            else
                                emit('cancel');
                        }
                    })
                        .catch(function (error) {
                        var _a;
                        if (axios_1.default.isAxiosError(error)) {
                            alert("Code:340 - System issue. Please contact system support");
                            console.error('Error posting data:', ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || error.message);
                            //  errorMessage = error.response?.data?.message || 'An error occurred while posting data.';  
                        }
                        else {
                            alert("Opps, we hit an unexpectant snag, please contact your system administrator if this error presist.");
                            console.log('Unexpected error:', error);
                            //  errorMessage = 'An unexpected error occurred. Please try again.'; 
                        }
                    });
                }
                catch (response) {
                    alert(response);
                }
            }
            else {
                //Add Allery Information IN this axios Call 
                var content = {
                    MedicationAdmin: {
                        API_Meth: "AddPatientAllergyInfo",
                        accountnumber: allData.value.patient.externId2, //"904575107", 
                        npinumber: allData.value.patient.npi, //"123456789",
                        proflicensenumber: allData.value.patient.npi, //"609382", //insurance test
                        patientid: allData.value.patient.externId, // "709081242",
                        ordernumber: '36',
                        params: allergyData,
                        medname: allergyData.name || 'N/A',
                        provsubaccount: actorSubaccount,
                        providername: actorName
                    }
                };
                axios_1.default.post(apis_1.CURR_API + "/tswebhook.php", content)
                    .then(function (response) {
                    console.log(response.data);
                    if (response.data && response.data != "" && response.data.status == "200-Successfull" && response.data.code == "1") {
                        console.log("Logging Results of Axios Call");
                        var added = stores.addAllergy(allergyData);
                        alert("Patient Allergy Added Successfully.");
                        emit('saved', added);
                    }
                    else if (response.data && response.data.message && response.data.code == 0) {
                        console.log(response.data.message);
                        alert("Unable to add Patient Allergy. Please contact administrator if problem persist. (code:304)");
                    }
                })
                    .catch(function (error) {
                    var _a;
                    if (axios_1.default.isAxiosError(error)) {
                        alert("Code:340 - Internal Error. Please contact system support");
                        console.error('Error posting data:', ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || error.message);
                        //  errorMessage = error.response?.data?.message || 'An error occurred while posting data.';  
                    }
                    else {
                        alert("Opps, we hit an unexpectant snag, please contact your system administrator if this error presist.");
                        console.log('Unexpected error:', error);
                        //  errorMessage = 'An unexpected error occurred. Please try again.'; 
                    }
                });
            }
        }
        // Load existing allergy data when editing
        (0, vue_3.watch)(function () { return props.allergyId; }, function (id) {
            if (id) {
                var allergy_1 = stores.getAllergyById(id);
                if (allergy_1) {
                    form.value = {
                        name: allergy_1.name,
                        type: allergy_1.type,
                        status: allergy_1.status,
                        severity: allergy_1.severity,
                        criticality: allergy_1.criticality,
                        reactions: __spreadArray([], allergy_1.reactions, true),
                        onsetDate: allergy_1.onsetDate || '',
                        resolvedDate: allergy_1.resolvedDate || '',
                        verificationStatus: allergy_1.verificationStatus,
                        comments: allergy_1.comments,
                        crossReactivity: __spreadArray([], allergy_1.crossReactivity, true)
                    };
                    // Set editor content
                    (0, vue_3.nextTick)(function () {
                        if (editorRef.value) {
                            editorRef.value.innerHTML = allergy_1.comments;
                        }
                    });
                }
            }
        }, { immediate: true });
        // Auto-select cross-reactivity items when allergy name changes
        (0, vue_3.watch)(function () { return crossReactivityWarnings.value; }, function (warnings) {
            if (!isEditing.value) {
                console.log("Wraning CROSS");
                console.log(warnings);
                form.value.crossReactivity = __spreadArray([], warnings, true);
                console.log("FormCross Calue");
                console.log(form.value.crossReactivity);
            }
        });
        (0, vue_3.onMounted)(function () {
            // Initialize editor with existing content if editing
            if (editorRef.value && form.value.comments) {
                editorRef.value.innerHTML = form.value.comments;
                //const stores = useAllergyStore()
            }
        });
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("button", {
                        class: "back-btn",
                        onClick: _cache[0] || (_cache[0] = function ($event) { return (_ctx.$emit('cancel')); })
                    }, __spreadArray([], (_cache[15] || (_cache[15] = [
                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-arrow-left bi bi-arrow-left" }, null, -1)
                    ])), true)),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("h3", null, (0, vue_2.toDisplayString)(isEditing.value ? 'Edit Allergy' : 'Add New Allergy'), 1),
                        (0, vue_2.createElementVNode)("p", null, (0, vue_2.toDisplayString)(isEditing.value ? 'Update allergy information and reactions' : 'Document a new allergy for this patient'), 1)
                    ])
                ]),
                (0, vue_2.createElementVNode)("form", {
                    onSubmit: (0, vue_2.withModifiers)(handleSubmit, ["prevent"]),
                    class: "form-body"
                }, [
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        _cache[28] || (_cache[28] = (0, vue_2.createElementVNode)("h4", { class: "section-title" }, [
                            (0, vue_2.createElementVNode)("span", { class: "section-icon" }, [
                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-info-sign bi bi-info" })
                            ]),
                            (0, vue_2.createTextVNode)(" Basic Information ")
                        ], -1)),
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                _cache[19] || (_cache[19] = (0, vue_2.createElementVNode)("label", { class: "required" }, "Allergy Name / Substance", -1)),
                                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                    _cache[16] || (_cache[16] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-search" }, null, -1)),
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((form.value.name) = $event); }),
                                        type: "text",
                                        placeholder: "Search or enter allergy name...",
                                        class: "form-input",
                                        required: "",
                                        onInput: searchAllergies
                                    }, null, 544), [
                                        [vue_2.vModelText, form.value.name]
                                    ])
                                ]),
                                (0, vue_2.createVNode)(vue_2.Transition, { name: "suggestions" }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (showSuggestions.value && suggestions.value.length > 0)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                                                (isSearching.value)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, __spreadArray([], (_cache[17] || (_cache[17] = [
                                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-refresh spinning bi bi-arrow-repeat spin-icon" }, null, -1),
                                                        (0, vue_2.createTextVNode)(" Searching RxNorm... ", -1)
                                                    ])), true)))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(suggestions.value, function (suggestion) {
                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                        key: suggestion.rxcui || suggestion.name,
                                                        type: "button",
                                                        class: "suggestion-item",
                                                        onClick: function ($event) { return (selectSuggestion(suggestion)); }
                                                    }, [
                                                        (0, vue_2.createElementVNode)("span", _hoisted_11, (0, vue_2.toDisplayString)(suggestion.name), 1),
                                                        (suggestion.rxcui)
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_12, "RxNorm"))
                                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_13, "Local"))
                                                    ], 8, _hoisted_10));
                                                }), 128))
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true)
                                    ]; }, undefined, true),
                                    _: 1
                                }),
                                (isSearching.value && !showSuggestions.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_14, __spreadArray([], (_cache[18] || (_cache[18] = [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-refresh spinning bi bi-arrow-repeat spin-icon" }, null, -1),
                                        (0, vue_2.createTextVNode)(" Searching... ", -1)
                                    ])), true)))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_15, [
                                _cache[21] || (_cache[21] = (0, vue_2.createElementVNode)("label", { class: "required" }, "Allergy Type", -1)),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((form.value.type) = $event); }),
                                    class: "form-select",
                                    required: ""
                                }, __spreadArray([], (_cache[20] || (_cache[20] = [
                                    (0, vue_2.createStaticVNode)("<option value=\"\" data-v-1a155eec>Select type...</option><option value=\"drug\" data-v-1a155eec>Drug / Medication</option><option value=\"food\" data-v-1a155eec>Food</option><option value=\"environmental\" data-v-1a155eec>Environmental</option><option value=\"biologic\" data-v-1a155eec>Biologic</option><option value=\"other\" data-v-1a155eec>Other</option>", 6)
                                ])), true), 512), [
                                    [vue_2.vModelSelect, form.value.type]
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                _cache[22] || (_cache[22] = (0, vue_2.createElementVNode)("label", null, "Onset Date", -1)),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((form.value.onsetDate) = $event); }),
                                    type: "date",
                                    class: "form-input"
                                }, null, 512), [
                                    [vue_2.vModelText, form.value.onsetDate]
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                _cache[24] || (_cache[24] = (0, vue_2.createElementVNode)("label", { class: "required" }, "Status", -1)),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((form.value.status) = $event); }),
                                    class: "form-select",
                                    required: ""
                                }, __spreadArray([], (_cache[23] || (_cache[23] = [
                                    (0, vue_2.createElementVNode)("option", { value: "active" }, "Active", -1),
                                    (0, vue_2.createElementVNode)("option", { value: "inactive" }, "Inactive", -1),
                                    (0, vue_2.createElementVNode)("option", { value: "resolved" }, "Resolved", -1),
                                    (0, vue_2.createElementVNode)("option", { value: "entered-in-error" }, "Entered in Error", -1)
                                ])), true), 512), [
                                    [vue_2.vModelSelect, form.value.status]
                                ])
                            ]),
                            (form.value.status === 'resolved')
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_18, [
                                    _cache[25] || (_cache[25] = (0, vue_2.createElementVNode)("label", null, "Resolved Date", -1)),
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((form.value.resolvedDate) = $event); }),
                                        type: "date",
                                        class: "form-input"
                                    }, null, 512), [
                                        [vue_2.vModelText, form.value.resolvedDate]
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (0, vue_2.createElementVNode)("div", _hoisted_19, [
                                _cache[27] || (_cache[27] = (0, vue_2.createElementVNode)("label", { class: "required" }, "Verification Status", -1)),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((form.value.verificationStatus) = $event); }),
                                    class: "form-select",
                                    required: ""
                                }, __spreadArray([], (_cache[26] || (_cache[26] = [
                                    (0, vue_2.createElementVNode)("option", { value: "confirmed" }, "Confirmed", -1),
                                    (0, vue_2.createElementVNode)("option", { value: "unconfirmed" }, "Unconfirmed", -1),
                                    (0, vue_2.createElementVNode)("option", { value: "refuted" }, "Refuted", -1),
                                    (0, vue_2.createElementVNode)("option", { value: "entered-in-error" }, "Entered in Error", -1)
                                ])), true), 512), [
                                    [vue_2.vModelSelect, form.value.verificationStatus]
                                ])
                            ])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_20, [
                        _cache[32] || (_cache[32] = (0, vue_2.createElementVNode)("h4", { class: "section-title" }, [
                            (0, vue_2.createElementVNode)("span", { class: "section-icon" }, [
                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-warning-sign bi-exclamation-triangle" })
                            ]),
                            (0, vue_2.createTextVNode)(" Severity & Criticality ")
                        ], -1)),
                        (0, vue_2.createElementVNode)("div", _hoisted_21, [
                            (0, vue_2.createElementVNode)("div", _hoisted_22, [
                                _cache[30] || (_cache[30] = (0, vue_2.createElementVNode)("label", { class: "required" }, "Severity", -1)),
                                (0, vue_2.createElementVNode)("div", _hoisted_23, [
                                    ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(severityOptions, function (option) {
                                        var _a;
                                        return (0, vue_2.createElementVNode)("label", {
                                            key: option.value,
                                            class: (0, vue_2.normalizeClass)(["severity-option", (_a = { selected: form.value.severity === option.value }, _a[option.value] = true, _a)])
                                        }, [
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                type: "radio",
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) { return ((form.value.severity) = $event); }),
                                                value: option.value,
                                                class: "sr-only"
                                            }, null, 8, _hoisted_24), [
                                                [vue_2.vModelRadio, form.value.severity]
                                            ]),
                                            _cache[29] || (_cache[29] = (0, vue_2.createElementVNode)("span", { class: "severity-dot" }, null, -1)),
                                            (0, vue_2.createElementVNode)("span", _hoisted_25, (0, vue_2.toDisplayString)(option.label), 1)
                                        ], 2);
                                    }), 64))
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_26, [
                                _cache[31] || (_cache[31] = (0, vue_2.createElementVNode)("label", { class: "required" }, "Criticality", -1)),
                                (0, vue_2.createElementVNode)("div", _hoisted_27, [
                                    ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(criticalityOptions, function (option) {
                                        return (0, vue_2.createElementVNode)("label", {
                                            key: option.value,
                                            class: (0, vue_2.normalizeClass)(["criticality-option", { selected: form.value.criticality === option.value }])
                                        }, [
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                type: "radio",
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) { return ((form.value.criticality) = $event); }),
                                                value: option.value,
                                                class: "sr-only"
                                            }, null, 8, _hoisted_28), [
                                                [vue_2.vModelRadio, form.value.criticality]
                                            ]),
                                            (0, vue_2.createElementVNode)("span", {
                                                class: (0, vue_2.normalizeClass)(["criticality-icon", option.value])
                                            }, [
                                                (option.value === 'high')
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_29))
                                                    : (option.value === 'low')
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_30))
                                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_31))
                                            ], 2),
                                            (0, vue_2.createElementVNode)("span", _hoisted_32, (0, vue_2.toDisplayString)(option.label), 1)
                                        ], 2);
                                    }), 64))
                                ])
                            ])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_33, [
                        _cache[37] || (_cache[37] = (0, vue_2.createElementVNode)("h4", { class: "section-title" }, [
                            (0, vue_2.createElementVNode)("span", { class: "section-icon" }, [
                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-flash bi bi-lightning" })
                            ]),
                            (0, vue_2.createTextVNode)(" Reactions / Manifestations ")
                        ], -1)),
                        (0, vue_2.createElementVNode)("div", _hoisted_34, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(allergyStore_1.MANIFESTATIONS), function (manifestation) {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", {
                                    key: manifestation,
                                    class: (0, vue_2.normalizeClass)(["manifestation-checkbox", { selected: isManifestationSelected(manifestation) }])
                                }, [
                                    (0, vue_2.createElementVNode)("input", {
                                        type: "checkbox",
                                        checked: isManifestationSelected(manifestation),
                                        onChange: function ($event) { return (toggleManifestation(manifestation)); },
                                        class: "sr-only"
                                    }, null, 40, _hoisted_35),
                                    _cache[33] || (_cache[33] = (0, vue_2.createElementVNode)("span", { class: "checkbox-indicator" }, [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-ok bi bi-check" })
                                    ], -1)),
                                    (0, vue_2.createElementVNode)("span", _hoisted_36, (0, vue_2.toDisplayString)(manifestation), 1)
                                ], 2));
                            }), 128))
                        ]),
                        (0, vue_2.createVNode)(vue_2.Transition, { name: "expand" }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (form.value.reactions.length > 0)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_37, [
                                        _cache[36] || (_cache[36] = (0, vue_2.createElementVNode)("h5", null, "Selected Reactions - Set Severity", -1)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_38, [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(form.value.reactions, function (reaction, idx) {
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                    key: idx,
                                                    class: "reaction-item"
                                                }, [
                                                    (0, vue_2.createElementVNode)("span", _hoisted_39, (0, vue_2.toDisplayString)(reaction.manifestation), 1),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                        "onUpdate:modelValue": function ($event) { return ((reaction.severity) = $event); },
                                                        class: "reaction-severity-select"
                                                    }, __spreadArray([], (_cache[34] || (_cache[34] = [
                                                        (0, vue_2.createElementVNode)("option", { value: "mild" }, "Mild", -1),
                                                        (0, vue_2.createElementVNode)("option", { value: "moderate" }, "Moderate", -1),
                                                        (0, vue_2.createElementVNode)("option", { value: "severe" }, "Severe", -1),
                                                        (0, vue_2.createElementVNode)("option", { value: "life-threatening" }, "Life-Threatening", -1)
                                                    ])), true), 8, _hoisted_40), [
                                                        [vue_2.vModelSelect, reaction.severity]
                                                    ]),
                                                    (0, vue_2.createElementVNode)("button", {
                                                        type: "button",
                                                        class: "remove-btn",
                                                        onClick: function ($event) { return (removeManifestation(idx)); }
                                                    }, __spreadArray([], (_cache[35] || (_cache[35] = [
                                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove bi bi-trash" }, null, -1)
                                                    ])), true), 8, _hoisted_41)
                                                ]));
                                            }), 128))
                                        ])
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ]; }, undefined, true),
                            _: 1
                        })
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_42, [
                        _cache[41] || (_cache[41] = (0, vue_2.createElementVNode)("h4", { class: "section-title" }, [
                            (0, vue_2.createElementVNode)("span", { class: "section-icon" }, [
                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-link bi bi-link" })
                            ]),
                            (0, vue_2.createTextVNode)(" Cross-Reactivity Alerts ")
                        ], -1)),
                        (crossReactivityWarnings.value.length > 0)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_43, [
                                _cache[39] || (_cache[39] = (0, vue_2.createElementVNode)("div", { class: "warning-banner" }, [
                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-exclamation-sign bi bi-exclamation" }),
                                    (0, vue_2.createElementVNode)("p", null, "Based on the allergy entered, the patient may also react to the following substances:")
                                ], -1)),
                                (0, vue_2.createElementVNode)("div", _hoisted_44, [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(crossReactivityWarnings.value, function (item) {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", {
                                            key: item,
                                            class: (0, vue_2.normalizeClass)(["cross-item-checkbox", { selected: form.value.crossReactivity.includes(item) }])
                                        }, [
                                            (0, vue_2.createElementVNode)("input", {
                                                type: "checkbox",
                                                checked: form.value.crossReactivity.includes(item),
                                                onChange: function ($event) { return (toggleCrossReactivity(item)); },
                                                class: "sr-only"
                                            }, null, 40, _hoisted_45),
                                            _cache[38] || (_cache[38] = (0, vue_2.createElementVNode)("span", { class: "checkbox-indicator" }, [
                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-ok bi bi-check" })
                                            ], -1)),
                                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(item), 1)
                                        ], 2));
                                    }), 128))
                                ])
                            ]))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_46, __spreadArray([], (_cache[40] || (_cache[40] = [
                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-info-sign bi bi-info" }, null, -1),
                                (0, vue_2.createElementVNode)("p", null, "No known cross-reactivity warnings for this substance.", -1)
                            ])), true)))
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_47, [
                        _cache[50] || (_cache[50] = (0, vue_2.createElementVNode)("h4", { class: "section-title" }, [
                            (0, vue_2.createElementVNode)("span", { class: "section-icon" }, [
                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-comment bi bi-chat" })
                            ]),
                            (0, vue_2.createTextVNode)(" Clinical Notes & Comments ")
                        ], -1)),
                        (0, vue_2.createElementVNode)("div", _hoisted_48, [
                            (0, vue_2.createElementVNode)("div", _hoisted_49, [
                                (0, vue_2.createElementVNode)("button", {
                                    type: "button",
                                    onClick: _cache[9] || (_cache[9] = function ($event) { return (formatText('bold')); }),
                                    class: (0, vue_2.normalizeClass)({ active: isFormatActive.value.bold })
                                }, __spreadArray([], (_cache[42] || (_cache[42] = [
                                    (0, vue_2.createElementVNode)("strong", null, "B", -1)
                                ])), true), 2),
                                (0, vue_2.createElementVNode)("button", {
                                    type: "button",
                                    onClick: _cache[10] || (_cache[10] = function ($event) { return (formatText('italic')); }),
                                    class: (0, vue_2.normalizeClass)({ active: isFormatActive.value.italic })
                                }, __spreadArray([], (_cache[43] || (_cache[43] = [
                                    (0, vue_2.createElementVNode)("em", null, "I", -1)
                                ])), true), 2),
                                (0, vue_2.createElementVNode)("button", {
                                    type: "button",
                                    onClick: _cache[11] || (_cache[11] = function ($event) { return (formatText('underline')); }),
                                    class: (0, vue_2.normalizeClass)({ active: isFormatActive.value.underline })
                                }, __spreadArray([], (_cache[44] || (_cache[44] = [
                                    (0, vue_2.createElementVNode)("u", null, "U", -1)
                                ])), true), 2),
                                _cache[48] || (_cache[48] = (0, vue_2.createElementVNode)("span", { class: "separator" }, null, -1)),
                                (0, vue_2.createElementVNode)("button", {
                                    type: "button",
                                    onClick: _cache[12] || (_cache[12] = function ($event) { return (formatText('insertUnorderedList')); })
                                }, __spreadArray([], (_cache[45] || (_cache[45] = [
                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-list" }, null, -1)
                                ])), true)),
                                (0, vue_2.createElementVNode)("button", {
                                    type: "button",
                                    onClick: _cache[13] || (_cache[13] = function ($event) { return (formatText('insertOrderedList')); })
                                }, __spreadArray([], (_cache[46] || (_cache[46] = [
                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-th-list" }, null, -1)
                                ])), true)),
                                _cache[49] || (_cache[49] = (0, vue_2.createElementVNode)("span", { class: "separator" }, null, -1)),
                                (0, vue_2.createElementVNode)("button", {
                                    type: "button",
                                    onClick: clearFormatting
                                }, __spreadArray([], (_cache[47] || (_cache[47] = [
                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove-sign" }, null, -1)
                                ])), true))
                            ]),
                            (0, vue_2.createElementVNode)("div", {
                                ref_key: "editorRef",
                                ref: editorRef,
                                class: "editor-content",
                                contenteditable: "true",
                                onInput: updateComments,
                                onKeyup: checkFormats,
                                onMouseup: checkFormats,
                                "data-placeholder": 'Enter clinical notes, observations, or relevant history about this allergy...'
                            }, null, 544)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_50, [
                        (0, vue_2.createElementVNode)("button", {
                            type: "button",
                            class: "btn-cancel",
                            onClick: _cache[14] || (_cache[14] = function ($event) { return (_ctx.$emit('cancel')); })
                        }, " Cancel "),
                        (0, vue_2.createElementVNode)("button", {
                            type: "submit",
                            class: "btn-save",
                            disabled: !isFormValid.value
                        }, [
                            _cache[51] || (_cache[51] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-ok" }, null, -1)),
                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(isEditing.value ? 'Update Allergy' : 'Save Allergy'), 1)
                        ], 8, _hoisted_51)
                    ])
                ], 32)
            ]));
        };
    }
});
